import { render, staticRenderFns } from "./CopyCabinetReferences.vue?vue&type=template&id=a779727c&scoped=true&"
import script from "./CopyCabinetReferences.vue?vue&type=script&lang=ts&"
export * from "./CopyCabinetReferences.vue?vue&type=script&lang=ts&"
import style0 from "./CopyCabinetReferences.vue?vue&type=style&index=0&id=a779727c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a779727c",
  null
  
)

export default component.exports